import type * as lazyFunctions from './lazyFunctions';
import { LazyBootModule, LazyAction, LazyImport } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule<typeof lazyFunctions>(
    () => import(/* webpackChunkName: "AppBootOutlookHeader" */ './lazyFunctions'),
    { name: 'AppBootOutlookHeader' }
);

export const lazyToggleMaximizeProxy: LazyAction<
    typeof lazyFunctions.lazyToggleMaximize.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyToggleMaximize.importAndExecute);

export const lazyCaptionButtonActionProxy: LazyAction<
    typeof lazyFunctions.lazyCaptionButtonAction.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyCaptionButtonAction.importAndExecute);

export const lazyOneOutlookSuiteHeaderProxy: LazyImport<
    typeof lazyFunctions.lazyOneOutlookSuiteHeader.import,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.lazyOneOutlookSuiteHeader.import);
